import { FormEvent } from 'react';
import { IListItem } from '@nkr/models/index';
import { Button, Col, ControlLabel, Form, FormControl, Panel } from 'react-bootstrap';

interface IProps {
    reviewerContactId: number,
    reviewers: IListItem[],
    onReviewerChange: (reviewerContactId: number) => void,
    onMarkReviewed: () => void
}

const ReviewDetails = (props: IProps) => {
    const handleReviewerChange = (e: FormEvent<FormControl & HTMLSelectElement>) => {
        props.onReviewerChange(parseInt(e.currentTarget.value));
    };

    return (
        <Panel bsStyle='info'>
            <Panel.Heading>
                <Panel.Title>Review Details</Panel.Title>
            </Panel.Heading>
            <Panel.Body>
                <Form horizontal>
                    <Col xs={12} sm={4} componentClass={ControlLabel}>Who completed the review?</Col>
                    <Col xs={12} sm={4}>
                        <FormControl
                            componentClass='select'
                            value={props.reviewerContactId}
                            onChange={handleReviewerChange}
                        >
                            <option value={0}>- Select -</option>
                            {props.reviewers.map(item =>
                                <option key={'rev-' + item.id} value={item.id}>{item.description}</option>
                            )}
                        </FormControl>
                    </Col>
                    <Col xs={12} sm={4}>
                        <Button bsStyle='primary' block disabled={props.reviewerContactId == 0} onClick={props.onMarkReviewed}>Mark Reviewed</Button>
                    </Col>
                </Form>
            </Panel.Body>
        </Panel>
    );
}

export default ReviewDetails;